import { render, staticRenderFns } from "./base-btn.vue?vue&type=template&id=26993ec6"
import script from "./base-btn.ts?vue&type=script&lang=ts&external"
export * from "./base-btn.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports